var path = 'app/scripts/modules/core/src/pipeline/manualExecution/notifications.tooltip.html';
var html = "<div class=\"notifications-list\">\n  <ul>\n    <li ng-repeat=\"notification in vm.notifications\">\n      <b>{{notification.address}}</b> when:\n      <ul>\n        <li ng-repeat=\"when in notification.when\">{{when|notificationWhen}}</li>\n      </ul>\n    </li>\n  </ul>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/manualExecution/notifications.tooltip.html
// module id = 1025
// module chunks = 0